export const SOPORTE_PDV: Record<
    string,
    { email: string, codigos: string[] }
> = {
    centro: {
        email: 'soportepdv_centro@simyo.es',
        codigos: ['05', '09', '13', '16', '19', '24', '35', '37', '38', '40', '42', '45', '47', '49']
    },
    sur: {
        email: 'soportepdv_sur@simyo.es',
        codigos: ['04', '06', '10', '11', '14', '18', '21', '23', '29', '41', '51', '52']
    },
    este: {
        email: 'soportepdv_este@simyo.es',
        codigos: ['02', '03', '08', '12', '17', '22', '25', '30', '31', '44', '46', '50']
    },
    interno: {
        email: 'soportepdv_directo@simyo.es',
        codigos: ['28', '43']
    },
    norte: {
        email: 'soportepdv_norte@simyo.es',
        codigos: ['01', '07', '15', '20', '26', '27', '32', '33', '34', '36', '39', '48']
    }
};